<template>
    <div class="van-keep h-full w-full center-flex container">
        <div class="content">
            <div class="hero">
                <img class="hero-logo" src="@/assets/img/logo.png" alt="logo" />
                <h1 class="hero-title">供应商协同工具</h1>
            </div>
            <div class="form-card">
                <form class="form" v-if="loading||(!linkExpired&&supplierInfo.YYMC)" @submit.prevent="handleSubmit">
                    <div class="form-header">
                        <template v-if="supplierInfo&&supplierInfo.YYMC">
                            <h1>企业信息完善</h1>
                            <p><span style="color:rgba(0, 0, 0, 0.65)">医院名称：</span>{{ supplierInfo.YYMC }}</p>
                            <p><span style="color:rgba(0, 0, 0, 0.65)">协作名称：</span>{{ supplierInfo.HTMC }}</p>
                            <p><span style="color:rgba(0, 0, 0, 0.65)" v-if="supplierInfo.HTDWMC">供应商名称：</span>{{ supplierInfo.HTDWMC }}</p>
                        </template>
                        <template v-else>
                            <h1 v-if="loading">加载医院中...</h1>
                            <h1 v-else>未获取到企业信息</h1>
                        </template>
                    </div>
                    <div class="form-body">
                        <label class="form-label">请输入校验码</label>
                        <input
                            v-model.trim="verifyCode"
                            class="form-input"
                            type="text"
                            placeholder=""
                            autocomplete="off"
                        />
                        <button type="submit" class="submit-btn">进入工具</button>
                            
                        <p class="date">链接将于{{ yxqText }}后失效，请尽快完成填写。</p>
                    </div>
                </form>
                <div v-else-if="linkExpired" class="form-illustration">
                    <img class="form-svg" :src="failureSvg" alt="illustration" />
                    <p v-if="supplierInfo.YXQ">该链接已失效！</p>
                    <p v-else>该链接无效！</p>
                </div> 
                <div v-else class="form-illustration">
                    <img class="form-svg" :src="failureSvg" alt="illustration" />
                    <p>{{errorText}}</p>
                </div> 
                
            </div>
        </div>
    </div>
</template>

<script>
import failureSvg from "@/assets/svg/failure.svg";
import { Toast, Popup, Picker } from "vant";
export default {
    name: "supCollabShare",
    data() {
        return {
            supplierInfo:{},
            loading:true,
            verifyCode: "",
            failureSvg,
            errorText:''
        };
    },
    components: {},
    computed: {
        yxqText() {
            if (!this.supplierInfo || !this.supplierInfo.YXQ) return "";
            return this.formatDateToCn(this.supplierInfo.YXQ, true);
        },
        linkExpired() {
            if (!this.supplierInfo || !this.supplierInfo.YXQ) return false;
            return this.isExpired(this.supplierInfo.YXQ, true);
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData(){
            let paramsId = this.$route.params.id||null
            if(!paramsId) return this.loading = false
            this.$get('api/HtTran/GetCTXQ', {
                HTBH: paramsId
            }).then(res=>{
                if(res.Status||res.status){
                    this.supplierInfo = res.Data
                    const expired = this.isExpired(this.supplierInfo.YXQ, true); // 当天23:59:59为截止
                    if (expired) {
                        // 这里写过期后的处理
                        this.$Toast.fail('该链接已失效！');
                    } 
                }else{
                    this.errorText = res.Msg
                }
                this.loading = false
            }).catch(_=>{
                this.loading = false
            })
        },
        // 将 ISO 日期字符串格式化为：YYYY年MM月DD日 HH时mm分ss秒
        // 当 endOfDay 为 true 时，时间固定为当日 23:59:59
        formatDateToCn(isoString, endOfDay = true) {
            const date = new Date(isoString);
            if (Number.isNaN(date.getTime())) return "";
            if (endOfDay) {
                date.setHours(23, 59, 59, 0);
            }
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, "0");
            const day = String(date.getDate()).padStart(2, "0");
            const hours = String(date.getHours()).padStart(2, "0");
            const minutes = String(date.getMinutes()).padStart(2, "0");
            const seconds = String(date.getSeconds()).padStart(2, "0");
            return `${year}年${month}月${day}日 ${hours}时${minutes}分${seconds}秒`;
        },
        // 是否晚于当前时间（默认比较当日 23:59:59）
        isAfterNow(isoString, endOfDay = true) {
            const date = new Date(isoString);
            if (Number.isNaN(date.getTime())) return false;
            if (endOfDay) date.setHours(23, 59, 59, 0);
            return date.getTime() > Date.now();
        },
        // 是否已过期（当前时间是否超过给定时间；默认按当日 23:59:59 截止）
        isExpired(isoString, endOfDay = true) {
            const date = new Date(isoString);
            if (Number.isNaN(date.getTime())) return true;
            if (endOfDay) date.setHours(23, 59, 59, 0);
            return Date.now() > date.getTime();
        },
        handleSubmit() {
            if (!this.verifyCode) {
               this.$Toast("请填写验证码");
                return;
            }
            // 可选：跳到失败页或停留展示插图
            //
            // TODO: 提交表单逻辑
            // this.$Toast && this.$Toast.success("提交成功");
            let paramsId = this.$route.params.id||null
            if(!paramsId) return 
            this.$get('api/HtTran/CheckXTCode', {
                JYM: this.verifyCode,
                HTBH: paramsId,
            }).then(res=>{
                if(res.Status||res.status){
                    this.$router.replace(`/sup-collab/index/${paramsId}`)
                    this.$store.commit('SET_SUP_COLLAB_SHARE_VERIFY_CODE', this.verifyCode);
                }else{
                    this.$Toast.fail(res.Msg||'验证失败！');
                }
            })
            .catch(_=>{
                this.$Toast.fail('验证失败！');
            })
            // /sup-collab-share?stack-key=6227acb0
        }
    }
};
</script>

<style scoped lang="scss">
.h-full {
    height: 100%;
}
.w-full {
    width: 100%;
}
.van-keep {
    &.container {
        background-color: #f0f2f5;
        overflow: hidden;
    }
    &.center-flex {
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 100vh;
        padding: 16px;
        box-sizing: border-box;
    }
    .content {
         min-width: 300px;

    }
    .hero {
        margin-top: -150px;
        text-align: center;
        .hero-logo {
            width: 160px;
        }
        .hero-title {
            margin: -6px 0 0;
            font-size: 20px;
            font-weight: 600;
            color: #333;
            margin-bottom: 18px;
        }
    }
    .form-card {
        width: 100%;
        max-width: 420px;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
        box-sizing: border-box;
        overflow: hidden;
    }
    .form {
        display: flex;
        flex-direction: column;
        gap: 14px;
        .form-header{
            padding: 24px 24px 12px;
            border-bottom: 1px solid #e1e2e4;
            h1{
                margin: 10px 0;
                font-size: 22px;
                color: #141414;
            }
            p{
                font-size: 14px;
                margin-bottom: 6px;
            }
        }
    }
    .form-body {
        display: flex;
        flex-direction: column;
        gap: 8px;
        padding: 12px 24px 24px;
        .date{
            font-size: 14px;
            color: #666; 
        }
    }
    .form-label {
        font-size: 14px;
        color: #333;
    }
    .form-input {
        height: 40px;
        padding: 0 12px;
        border: 1px solid #e5e5e5;
        border-radius: 6px;
        font-size: 14px;
        outline: none;
        transition: border-color 0.2s ease;
    }
    .form-input:focus {
        border-color: #1989fa;
    }
    .submit-btn {
        margin-top: 6px;
        height: 40px;
        border: none;
        border-radius: 6px;
        background: #1989fa;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        transition: opacity 0.2s ease;
    }
    .submit-btn:active {
        opacity: 0.85;
    }
    .form-svg{
        width: 246px;
        margin: 30px auto;
        display: block;
    }
    .form-illustration{
        text-align: center;
        p{
            margin-bottom: 30px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/supplierCollaboration/verify.vue